module.exports = __webpack_public_path__ + "static/media/22_plantilla_combo_rectangular_marco_comida_32.b067e8b9.png";